<script lang="ts">
  import {svgMap} from './svgMap';

  export let name: keyof typeof svgMap;
  export let width = '24';
  export let height = '24';
  export let color = 'currentColor';
  export let pathColor = '';
  export let theme = 'dark';
  export let id = ''
  export {className as class};

  let className = '';

  $: svgContent = svgMap[name] || '';
</script>

<style>
  .icon-wrapper {
    display: inline-block;
    width: var(--width, 24px);
    height: var(--height, 24px);
    line-height: 0;
    font-size: 0;
    color: var(--color, #ffffff);
  }
  .icon-wrapper :global(svg) {
    width: 100%;
    height: 100%;
  }
</style>

{#if svgContent}
  <div id={id} class="icon-wrapper {className}" style="--width: {width}px; --height: {height}px; --green-main: {theme === 'dark' ? '#1DBF53' : '#33D43E'}; --color: {color};" on:click>
    {#if pathColor}
      {@html svgContent.replace(/fill="[^"]*"/g, `fill="${pathColor}"`)}
    {:else}
      {@html svgContent}
    {/if}
  </div>
{/if}
